'use client';

import dynamic from 'next/dynamic';
import { Box, Skeleton } from '@mui/material';

// Matches FeaturedMarketSlide's own grid shape/heights so swapping in the real
// (recharts-backed) component causes no layout shift once its chunk loads.
const FeaturedMarketSlideLoading = () => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 0.9fr) minmax(0, 1.1fr)' },
      gap: { xs: 2, md: 3 },
    }}
  >
    <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Skeleton variant="rounded" height={48} />
      <Skeleton variant="rounded" height={40} />
      <Skeleton variant="rounded" height={40} />
    </Box>
    <Skeleton variant="rounded" sx={{ height: { xs: 200, md: 240 }, width: '100%' }} />
  </Box>
);

export const FeaturedMarketSlide = dynamic(
  () => import('./FeaturedMarketSlide').then((mod) => mod.FeaturedMarketSlide),
  { ssr: false, loading: FeaturedMarketSlideLoading }
);
